//https://mindicador.cl/
export const endPoint = 'https://mindicador.cl/api/' //https://mindicador.cl/api/
export const unidadMedida = {
    dolar: 'US',
    peso: '$',
    porcentaje: '%'
}